import { compareStrings } from '@/filters/helpers';

function normalizeRoleRef(value) {
  return String(value || '');
}

export function roleRefsMatch(assignedRef, role) {
  const assigned = normalizeRoleRef(assignedRef);
  if (!assigned || !role) return false;

  const roleId = normalizeRoleRef(role.id);
  const roleSlug = normalizeRoleRef(role.slug);

  return (
    assigned === roleId ||
    (roleSlug && assigned === roleSlug) ||
    (roleSlug && assigned === `system_${roleSlug}`)
  );
}

export function userHasRole(user, role) {
  const userRoleIds = user?.roles || [];
  if (!userRoleIds.length || !role) return false;

  return userRoleIds.some((assignedRef) => roleRefsMatch(assignedRef, role));
}

export function getUsersWithRole(users, role, currentUser = null) {
  if (!role) return [];

  const pool = [...(users || [])];

  if (currentUser && userHasRole(currentUser, role)) {
    const currentId = normalizeRoleRef(currentUser.id);
    if (!pool.some((user) => normalizeRoleRef(user.id) === currentId)) {
      pool.push(currentUser);
    }
  }

  return pool.filter((user) => userHasRole(user, role));
}

export function getUserRoleNames(user, orgRoles = []) {
  const userRoleIds = user?.roles || [];
  if (!userRoleIds.length) return [];

  return orgRoles
    .filter((role) => userRoleIds.some((ref) => roleRefsMatch(ref, role)))
    .map((role) => role.name)
    .filter(Boolean);
}

export function userHasMatchingRole(user, search, orgRoles = []) {
  if (!search) return false;

  const userRoleIds = user?.roles || [];
  if (!userRoleIds.length) return false;

  return orgRoles
    .filter((role) => userRoleIds.some((ref) => roleRefsMatch(ref, role)))
    .some(
      (role) =>
        compareStrings(role.name, search) || compareStrings(role.slug, search)
    );
}
